"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2973],{

/***/ 2973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FooterBarEmpty": function() { return /* reexport */ FooterBarEmpty; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
;// CONCATENATED MODULE: ./src/components/FooterBarEmpty/FooterBarEmpty.tsx





var FooterBarEmpty = function() {
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var AzerionBrandContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
        target: "ejy1qx10"
    })(function() {
        return {
            backgroundColor: "black",
            color: "white"
        };
    });
    var AzerionBrandContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
        target: "ejy1qx11"
    })(function() {
        return {
            backgroundColor: "black",
            color: "white",
            marginLeft: "30px",
            padding: "10px 0"
        };
    });
    var azerionBrand = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_footer_bar_azerion_footer;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: azerionBrand && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AzerionBrandContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AzerionBrandContent, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    src: "/images/azerion-brand.png",
                    loader: function(param) {
                        var src = param.src, width = param.width;
                        return "".concat(src, "?w=").concat(width || 180);
                    },
                    alt: "made-with-love",
                    height: "30",
                    width: "180"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarEmpty/index.tsx



/***/ })

}]);